import React from "react";

import { translation } from "@/i18n";
import { nsDialog } from "@/i18n/locales/dialog";
import { useDialogStyles } from "@/styles";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import { ErrorCircle24Filled } from "@fluentui/react-icons";
import { DialogAPIErrorParam } from "../hooks";
import styles from "../index.module.css";

const useTranslation = translation.use(nsDialog);

export const DialogAPIError: React.FC<DialogAPIErrorParam> = ({
  displayMessage,
  errorCode,
  setErrorCode,
  responseMessage,
  setResponseMessage,
  dialogPhase,
  setDialogPhase,
  onClick,
}) => {
  const { t } = useTranslation();
  const dialogClasses = useDialogStyles();
  return (
    <Dialog open={dialogPhase === "errorAPI"}>
      <DialogSurface className={dialogClasses.dialog}>
        <DialogBody>
          <DialogTitle>
            <div className={styles.titleWithIcon}>
              <ErrorCircle24Filled className={styles.errorIcon} />
              {displayMessage}
            </div>
          </DialogTitle>
          <DialogContent>
            <div className={styles.errorInfoTitle}>
              {t.dialog.error.codeLabel()}
            </div>
            <div className={styles.errorResponse}>{errorCode}</div>
            <div className={styles.errorInfoTitle}>
              {t.dialog.error.messageLabel()}
            </div>
            <div className={styles.errorResponse}>
              {responseMessage.map((v) => {
                return <div key={v}>{v}</div>;
              })}
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setDialogPhase(null);
                setResponseMessage([]);
                setErrorCode("");
                onClick && onClick();
              }}
            >
              {t.dialog.common.backButton()}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
